import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProjectsTable } from '@/components/settings/projects-table';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute('/_auth/_side-layout/settings_/projects')({
  component: ProjectsSettingsPage,
  beforeLoad: async ({ context }) => {
    if (!hasPermission(context.userRole, { project: ['create'] })) {
      throw redirect({ to: '/' });
    }
  },
});

function ProjectsSettingsPage() {
  return <ProjectsTable />;
}
